export default "__VITE_ASSET__DSV9cgZM__"